module.exports = __webpack_public_path__ + "media/images/banks/vn-vietcom-baf96692c065787a597e2beadcaeea84.png";